'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Terms() {
	const { t } = useTranslation();

	return (
		<div className=' text-gray-800 min-h-screen py-12 my-12 leading-loose'>
			<section className='h-[30vh] bg-main flex justify-center items-center text-white text-4xl font-bold'>
				<h2>{t('terms')}</h2>
			</section>
			<div className='max-w-5xl mx-auto px-6 md:px-20'>
				<div className='space-y-6 text-right '>
					<p className='font-bold text-xl mt-16'>
						مرحباً بك في شروط استخدام منصة AI COURSES. عند استخدامك لمنصتنا فإنك
						توافق على الالتزام بجميع الشروط والأحكام الواردة في هذه الصفحة.
					</p>

					<h2 className='text-xl font-semibold text-black'>١. المقدمة</h2>
					<p>
						هذه الشروط والأحكام تنظم كيفية استخدامك لموقع ومنتجات منصة AI
						COURSES. باستخدامك للموقع أو أي من خدماته، فإنك توافق على هذه
						الشروط. إذا لم توافق على أي جزء من الشروط، يجب عليك التوقف فوراً عن
						استخدام الموقع.
					</p>

					<h2 className='text-xl font-semibold text-black'>٢. حساب المستخدم</h2>
					<p>
						قد تحتاج إلى إنشاء حساب لاستخدام بعض الخدمات. يجب عليك تقديم معلومات
						دقيقة وكاملة، والحفاظ على سرية بيانات الدخول الخاصة بك. أنت مسؤول عن
						أي نشاط يحدث باستخدام حسابك.
					</p>

					<h2 className='text-xl font-semibold text-black'>
						٣. الالتزام بالمحتوى والقوانين
					</h2>
					<p>
						يلتزم المستخدم بعدم استخدام منصة AI COURSES لأي أغراض غير قانونية أو
						مخالفة للأعراف أو تسبب ضرراً بالغير. يحق للمنصة إزالة أي محتوى مخالف
						دون إشعار مسبق.
					</p>

					<h2 className='text-xl font-semibold text-black'>
						٤. الملكية الفكرية
					</h2>
					<p>
						جميع حقوق النشر والملكية الفكرية للمحتوى والمواد المنشورة عبر منصة
						AI COURSES هي ملك للمنصة أو للجهات المانحة للترخيص. لا يحق لك إعادة
						إنتاج أو نشر أو استخدام المحتوى لأي أغراض تجارية بدون إذن مكتوب
						مسبق.
					</p>

					<h2 className='text-xl font-semibold text-black'>
						٥. حدود المسؤولية
					</h2>
					<p>
						لا تتحمل منصة AI COURSES أي مسؤولية عن أي أضرار مباشرة أو غير مباشرة
						تنشأ عن استخدامك للخدمات أو عدم قدرتك على استخدامها. استخدامك
						للخدمات يكون على مسؤوليتك الشخصية.
					</p>

					<h2 className='text-xl font-semibold text-black'>
						٦. التعديلات على الشروط
					</h2>
					<p>
						تحتفظ منصة AI COURSES بحق تعديل أو تحديث هذه الشروط في أي وقت. سيتم
						نشر التعديلات على هذه الصفحة وتصبح سارية فور نشرها. استمرارك في
						استخدام الخدمات بعد التعديلات يعني موافقتك عليها.
					</p>

					<h2 className='text-xl font-semibold text-black'>
						٧. القانون المعمول به
					</h2>
					<p>
						تخضع هذه الشروط وتُفسر وفقاً للقوانين المحلية والدولية المعمول بها،
						وأي نزاع يخضع لاختصاص المحاكم المختصة.
					</p>

					<h2 className='text-xl font-semibold text-black'>
						٨. معلومات التواصل
					</h2>
					<p>
						في حال وجود أي استفسارات بخصوص هذه الشروط، يمكنك التواصل معنا عبر
						البريد الإلكتروني الخاص بـ المنصه.
					</p>
				</div>
			</div>
		</div>
	);
}
